import { FaRegBell, FaSistrix, FaBars } from "react-icons/fa";
import AvatarImage from "../../assests/images/avatar.png";

function Header() {

    let getSideBarStatus = false, sideBarAlias;

    function clickEventHandler() {
        getSideBarStatus = true;
        let getSideBar = document.querySelector(".sideBar");
        let getXmark = document.querySelector(".xmark");
        getXmark.onclick = (e) => {
            getSideBar.style =
                "left:-220px !important;box-shadow:none;";
            getSideBarStatus = true;
            if (getSideBar.classList.contains("sidebar-active")) {
                getSideBar.classList.remove("sidebar-active");
            }
        };
        sideBarAlias = getSideBar;
        getSideBar.style = "left:0px !important;";
        getSideBar.classList.add("sidebar-active");

        document.onclick = (e) => {
            if (getSideBar.classList.contains("sidebar-active")) {
                if (
                    !e.target.classList.contains("bar-item") &&
                    e.target.tagName !== "path" &&
                    !e.target.classList.contains("sideBar") &&
                    !e.target.classList.contains("brand")
                ) {
                    getSideBar.style =
                        "left:-220px !important;box-shadow:none;";
                    getSideBar.classList.remove("sidebar-active");
                    getSideBarStatus = true;
                }
            }
        };
    }
    window.addEventListener("resize", (e) => {
        if (getSideBarStatus === true) {
            if (e.target.innerWidth > 768) {
                sideBarAlias.style = "left:0px !important;"
            } else {
                sideBarAlias.style =
                    "left:-220px !important";
            }
        }

    })

    return (
        <div className=" h-16 bg-white p-4 flex justify-between items-center shadow-sm">

            <form>
                <div className=" flex gap-4 items-center">
                    <FaBars className="bar-item hover:cursor-pointer md:hidden " onClick={clickEventHandler} />
                    <div className="relative">
                        <input type="search" name="search" placeholder="Type A Keyword" className=" text-gray-500 text-sm p-2 pl-6 rounded-lg placeholder:text-sm placeholder:text-gray-500 focus:outline-none border border-gray-500" />
                        <FaSistrix className="absolute top-1/2 -translate-y-1/2 left-1 text-gray-500 font-light text-base" />
                    </div>
                </div>
            </form>
            <div className="flex gap-1 items-center relative  before:absolute before:w-2 before:h-2 before:right-10 before:top-[2px] before:rounded-full before:bg-red-600">
                <FaRegBell className=" text-[21px]" />
                <img src={AvatarImage} alt="" className="w-9" />
            </div>
        </div>
    )
}

export default Header